<div class="grid justify-content-start">
  <div class="col-12 sm:col-6">
    <div [ngSwitch]="customerPayment.status">
      <ng-container *ngSwitchCase="'processing'">
        <h3 class="approved-header-text" id="payment-pending-header">
          {{
            (this.hasMultipleTransactions
              ? 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_MULTIPLE_PENDING'
              : 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_PENDING'
            ) | translate
          }}
        </h3>
        <div class="approved-icon-circle">
          <aur-icon
            id="payment-pending-icon"
            class="payment-status-icon payment-pending-icon"
            >hourglass_empty
          </aur-icon>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'some_processing'">
        <h3 class="approved-header-text" id="payment-pending-header">
          {{ 'ARC_PAYMENT_PAYMENTS_PENDING_MSG' | translate }}
        </h3>
        <div class="approved-icon-circle">
          <aur-icon
            id="payment-pending-icon"
            class="payment-status-icon payment-pending-icon"
            >hourglass_empty
          </aur-icon>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'some_failed'">
        <h3 class="approved-header-text" id="payment-pending-header">
          {{ 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_SOME_FAILED' | translate }}
        </h3>
        <div class="approved-icon-circle">
          <aur-icon
            id="payment-pending-icon"
            class="payment-status-icon payment-failed-icon"
            >error
          </aur-icon>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <h3 class="approved-header-text" id="payment-approved-header">
          {{ approvedHeaderKey | translate }}
        </h3>
        <div class="approved-icon-circle">
          <aur-icon id="payment-success-icon" class="payment-status-icon"
            >check</aur-icon
          >
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="grid">
  <div class="col-12 sm:col-6 lg:col-3" *ngIf="!this.hasMultipleTransactions">
    <aur-key-value
      id="confirmationNumberId"
      label="{{ 'ARC_PAYMENT_CONFIRMATION_NUMBER' | translate }}"
      >{{ customerPayment.masterConfirmationNumber }}</aur-key-value
    >
  </div>
  <div class="col-12 sm:col-6 lg:col-3">
    <aur-key-value
      id="cardIssuerId"
      label="{{ 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_METHOD' | translate }}"
      >{{ customerPayment.paymentMethodDisplayName }}</aur-key-value
    >
    <payment-autopay-badge
      id="autopayBadge"
      *ngIf="isAutopaySupported && isAutopayEnabled !== null"
      [isAutopayEnabled]="isAutopayEnabled"
    ></payment-autopay-badge>
  </div>
  <div class="col-12 sm:col-6 lg:col-3">
    <aur-key-value
      id="paymentDateKeyId"
      label="{{
        (customerPayment.isScheduledPayment
          ? 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_DATE'
          : 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_DATE_TIME'
        ) | translate
      }}"
    >
      <!-- The agnostic flag on this component determines whether the date is converted to the user's local
           time. In this case, scheduled payments should only display the date portion so there is no need to
           convert to the user's local time zone. -->
      <div id="paymentDateValueId">
        {{
          customerPayment.paymentDate
            | localDate: !customerPayment.isScheduledPayment
            | async
        }}
      </div>
      <!-- This component uses momentJs under the hood -->
    </aur-key-value>
  </div>
  <div class="col-12 sm:col-6 lg:col-3">
    <aur-key-value
      id="paymentTypeId"
      label="{{ 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_TYPE' | translate }}"
      >{{ 'ARC_PAYMENT_SUMMARY_HEADER_ONLINE_PAYMENT' | translate }}
    </aur-key-value>
  </div>
</div>

<div class="grid">
  <div class="col-12 sm:col-6 lg:col-3" *ngIf="!this.hasMultipleTransactions">
    <aur-key-value
      id="payorAccountNumberId"
      label="{{ 'ARC_PAYMENT_SUMMARY_HEADER_PAYOR_ACCOUNT' | translate }}"
      >{{ transactionBuyerAccounts[0] }}</aur-key-value
    >
  </div>
  <div class="col-12 sm:col-6 lg:col-3">
    <aur-key-value
      id="subTotalId"
      label="{{ 'ARC_PAYMENT_SUBTOTAL' | translate }}"
      >{{ transactionsSubTotal | currency }}
      {{ customerPayment.currency }}</aur-key-value
    >
    <aur-key-value
      id="subTotalDiscountAmountId"
      *ngIf="isDiscountAmountVisible"
    >
      ({{ transactionsAppliedDiscountTotal | currency }}
      {{ customerPayment.currency }}
      {{ 'ARC_PAYMENT_DISCOUNT_APPLIED' | translate | titlecase }})
    </aur-key-value>
  </div>

  <div class="col-12 sm:col-6 lg:col-3" *ngIf="transactionsCreditTotal">
    <aur-key-value
      id="creditMemoSubTotalId"
      label="{{ 'ARC_PAYMENT_CREDIT_MEMO_AMOUNT' | translate }}"
      >{{ transactionsCreditTotal | currency }}
      {{ customerPayment.currency }}</aur-key-value
    >
  </div>
  <div *ngIf="isSurchargeFeeVisible" class="col-12 sm:col-6 lg:col-3">
    <aur-key-value
      id="convenienceFeeId"
      label="{{
        ('ARC_PAYMENT_SUMMARY_HEADER_CREDIT_CARD_SERVICE_FEE' | translate) +
          (isSurchargeFeePercentageVisible
            ? ' (' + (surchargePercentage | number: '1.2-2') + '%' + ')'
            : '')
      }}"
    >
      {{ transactionsSurchargeTotal | currency }}
      {{ customerPayment.currency }}</aur-key-value
    >
  </div>

  <div class="col-12 sm:col-6 lg:col-3">
    <aur-key-value
      id="totalId"
      label="{{ 'ARC_PAYMENT_SUMMARY_HEADER_TOTAL_AMOUNT_PAID' | translate }}"
      >{{ transactionsTotal | currency }}
      {{ customerPayment.currency }}</aur-key-value
    >
  </div>
</div>

<autopay-enrollment-banner
  *ngIf="showAutopayEnrollmentBanner"
  [variant]="autopayBannerVariant"
  (enrollClicked)="enrollInAutopayClicked.emit()"
></autopay-enrollment-banner>
